export default __webpack_public_path__ + "assets/front/scss/notice-complete.140313f009d6720c2b7efc1b12623cb4.css";